/**
 * Owner: Masa Bayu
 * File: qx-writer-import-fraction.ts
 * Date:Time: 2026-10-29 20:30
 * Description: Fraction of pages opened, from the import hint only.
 */

export function importPageFraction(hint: string): number | null {
  const match = /Opening page (\d+) of (\d+)/.exec(hint);
  if (!match) return null;
  const page = Number(match[1]);
  const total = Number(match[2]);
  if (!Number.isInteger(page) || !Number.isInteger(total) || total < 1) return null;
  return Math.min(1, Math.max(0, page / total));
}
